export const blockIconsAudioandvideoStop = (
	<span className='material-symbols-outlined'>stop</span>
);
